'use strict'

import {bootstrap} from '../bootstrap/bootstrap'
import {easeScrollTo} from '../shared/utils'

const wizard = document.querySelector('.layout[data-section="wizard"]')
const arrow = document.querySelector('.scroll-to')
const navigation = document.querySelector('nav.navigation')

function scrollOnClickHandler(el) {
  let navigationHeight = 0

  bootstrap(navigation, navigation => navigationHeight = navigation.getBoundingClientRect().height)
  el.addEventListener('click', e => {
    e.preventDefault()
    bootstrap(wizard.getBoundingClientRect().top - navigationHeight, easeScrollTo)
  })
}

bootstrap(arrow, scrollOnClickHandler)
